import React, { useState, useEffect } from 'react';

// Custom hook for responsive breakpoints
const useResponsive = () => {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    screenWidth,
    isMobile: screenWidth < 640,
    isTablet: screenWidth >= 640 && screenWidth < 1024,
    isDesktop: screenWidth >= 1024,
    isSmall: screenWidth < 375,
    isLarge: screenWidth >= 1440
  };
};

const HeroSection = () => {
  const { screenWidth, isMobile, isTablet, isDesktop, isSmall, isLarge } = useResponsive();

  const getHeroStyles = () => ({
    container: {
      width: '100vw',
      maxWidth: '100%',
      height: isMobile ? '100vh' : isTablet ? '85vh' : '90vh',
      minHeight: isMobile ? '100vh' : isTablet ? '600px' : '700px',
      backgroundColor: '#000000',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: isMobile ? '20px 16px' : isTablet ? '40px 24px' : '60px 32px',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
      boxSizing: 'border-box',
      margin: 0
    },
    background: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `
        radial-gradient(circle at 20% 80%, rgba(204, 85, 0, 0.08) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.08) 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, rgba(120, 200, 255, 0.05) 0%, transparent 50%)
      `,
      zIndex: 1
    },
    content: {
      position: 'relative',
      zIndex: 2,
      maxWidth: '100%',
      width: '100%',
      boxSizing: 'border-box'
    },
    title: {
      fontSize: isSmall ? '28px' : 
               isMobile ? '36px' : 
               isTablet ? '52px' : 
               isLarge ? '72px' : '64px',
      fontWeight: '900',
      color: '#FFFFFF',
      letterSpacing: isMobile ? '1px' : isTablet ? '2px' : '2.5px',
      lineHeight: isMobile ? '1.1' : '1.2',
      marginBottom: isMobile ? '20px' : isTablet ? '24px' : '32px',
      textTransform: 'uppercase',
      maxWidth: '100%',
      wordBreak: 'break-word',
      textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
      padding: 0
    },
    subtitle: {
      fontSize: isSmall ? '14px' : 
                isMobile ? '16px' : 
                isTablet ? '24px' : 
                isLarge ? '32px' : '28px',
      fontWeight: '600',
      color: '#e60000',
      letterSpacing: isMobile ? '0.5px' : isTablet ? '1px' : '1.2px',
      lineHeight: isMobile ? '1.3' : '1.4',
      marginBottom: isMobile ? '32px' : isTablet ? '40px' : '48px',
      textTransform: 'uppercase',
      maxWidth: '100%',
      wordBreak: 'break-word',
      padding: 0
    }
  });

  const getButtonStyle = (isHover = false) => ({
    backgroundColor: isHover ? '#e60000' : 'transparent',
    color: '#FFFFFF',
    border: isHover ? '2px solid #e60000' : '2px solid #FFFFFF',
    padding: isMobile ? '16px 32px' : isTablet ? '18px 40px' : '20px 48px',
    fontSize: isMobile ? '16px' : isTablet ? '18px' : '20px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: isMobile ? '1px' : '1.5px',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    display: 'inline-block',
    minWidth: isMobile ? '180px' : isTablet ? '200px' : '220px',
    textAlign: 'center',
    boxShadow: isHover 
      ? '0 12px 35px rgba(204,85,0,0.4)' 
      : '0 6px 20px rgba(204,85,0,0.2)',
    transform: isHover ? 'translateY(-3px) scale(1.02)' : 'translateY(0) scale(1)',
    backdropFilter: 'blur(10px)'
  });

  const styles = getHeroStyles();

  return (
    <div style={styles.container}>
      <div style={styles.background}></div>
      
      <div style={styles.content}>
        <h1 style={styles.title}>
          WELCOME TO HOTMESS
        </h1>
        
        <p style={styles.subtitle}>
          ALWAYS TOO MUCH, YET NEVER ENOUGH
        </p>
        
        <a
          href="/"
          style={getButtonStyle()}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, getButtonStyle(true));
          }}
          onMouseLeave={(e) => {
            Object.assign(e.target.style, getButtonStyle(false));
          }}
          onTouchStart={(e) => {
            Object.assign(e.target.style, getButtonStyle(true));
          }}
          onTouchEnd={(e) => {
            Object.assign(e.target.style, getButtonStyle(false));
          }}
        >
          LISTEN LIVE
        </a>
      </div>
    </div>
  );
};

export default HeroSection;